export default function Map() {
  const setupOverviewMap = async (data, mapElement) => {
    const { LatLngBounds } = await google.maps.importLibrary('core');
    const { Map, InfoWindow } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

    const response = await fetch(data.url);
    const markers = await response.json();

    const map = new Map(mapElement, {
      center: { lat: 39.1431881, lng: -88.5286536 },
      zoom: 7,
      mapId: 'billboard_overview',
    });

    const infoWindow = new InfoWindow();
    const bounds = new LatLngBounds();

    let activeMarker = null;

    markers.forEach((markerData) => {
      const latLng = { lat: markerData.lat, lng: markerData.lng };
      const marker = new AdvancedMarkerElement({
        map: map,
        position: latLng,
        gmpClickable: true,
        title: data.title,
      });

      marker.addListener('click', ({ domEvent, latLng }) => {
        // const { target } = domEvent;

        if (marker === activeMarker) {
          const link = document.createElement('a');
          link.href = markerData.url;
          link.click();
        } else {
          infoWindow.close();
          let content = `<a class="tw-group tw-min-w-48 tw-block tw-group" href="${markerData.url}">
              <h3 class="tw-font-bold tw-mb-1"># ${markerData.number}</h3>
              <p class="tw-mb-2"><strong>Impressions</strong>: ${markerData.impressions}<br />`;
          if (markerData.direction)
            content += `<strong>Faces</strong>: ${markerData.direction}<br />`;
          if (markerData.roadside)
            content += `<strong>Side of the road</strong>: ${markerData.roadside}`;
          content += `</p><div class="tw-inline-flex tw-h-10 tw-px-6 tw-rounded-full tw-items-center tw-justify-center tw-bg-lavender tw-text-blue group-hover:tw-bg-emerald group-hover:tw-text-white w-o-format-btn-sm tw-whitespace-nowrap">Request quote</div>
            </a>`;
          infoWindow.setContent(content);
          infoWindow.open(marker.map, marker);
          activeMarker = marker;
        }
      });
      bounds.extend(latLng);
    });
    map.fitBounds(bounds);
  };
  const setupDetailMap = async (data, mapElement) => {
    const { Map, InfoWindow } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

    const position = {
      lat: parseFloat(data.lat),
      lng: parseFloat(data.lng),
    };

    const map = new Map(mapElement, {
      center: position,
      zoom: 12,
      mapId: 'billboard_detail_view',
    });

    const infoWindow = new InfoWindow();

    const marker = new AdvancedMarkerElement({
      map: map,
      position: position,
      gmpClickable: true,
      title: data.title,
    });

    marker.addListener('click', ({ domEvent, latLng }) => {
      // const { target } = domEvent;

      infoWindow.close();
      infoWindow.setContent(marker.title);
      infoWindow.open(marker.map, marker);
    });
  };

  return {
    init: async () => {
      const mapElement = document.querySelector('[data-w-map]');
      if (!mapElement) return;

      const data = JSON.parse(mapElement.getAttribute('data-w-map'));
      if (!data || !data.type) return;

      if (data.type === 'overview') await setupOverviewMap(data, mapElement);
      else if (data.type === 'detail') await setupDetailMap(data, mapElement);
    },
  };
}
